// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectLandTenureQueryResult, selectLandTenuresPageLoading, selectLandTenuresShowInitWaitingMessage} from '../_selectors/land-tenure.selectors';

export class LandTenuresDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectLandTenuresPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectLandTenuresShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectLandTenureQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
